export const PAGE_HEADING_ID = 'page-heading';
export const PRE_LOGIN_SNA_DRAWER_TITLE_ID = 'pre-login-sna-drawer-title';
export const PRE_LOGIN_SNA_DIALOG_TITLE_ID = 'pre-login-sna-dialog-title';
export const PRE_LOGIN_TERMS_DIALOG_TITLE_ID = 'pre-login-terms-dialog-title';
export const PRE_LOGIN_PRIVACY_DIALOG_TITLE_ID = 'pre-login-privacy-dialog-title';
export const PRE_LOGIN_CANCEL_DRAWER_TITLE_ID = 'pre-login-cancel-drawer-title';
export const PRE_LOGIN_CANCEL_DRAWER_SUBTITLE_ID = 'pre-login-cancel-drawer-subtitle';
export const PIN_SETUP_TITLE_ID = 'pin-setup-title';
export const PIN_CONFIRM_TITLE_ID = 'pin-confirm-title';
export const PIN_SUCCESS_TITLE_ID = 'pin-success-title';
export const PIN_FAILURE_TITLE_ID = 'pin-failure-title';
export const MORE_DETAILS_DIALOG_TITLE_ID = 'more-details-dialog-title';
export const VOICE_ERROR_DETAILS_TITLE_ID = 'voice-error-details-title';
export const NO_ACCOUNT_RADIO_GROUP_LABEL_ID = 'no-account-radio-group-label';
